function emailOverlay() {
    // const body = document.querySelector(".js-body");
    // const openEmailOverlay = document.querySelector(".js-enquire-button"),
    const emailOverlay = document.querySelector(".js-email-overlay"),
    closeEmailOverlay = document.querySelector(".js-close-overlay-button"),
    stopScrollingClass = "stop-scrolling",
    isActiveClass = "is-active";

    //open timeline
    const emailOpenTl = gsap.timeline({ paused:true });
    emailOpenTl.to(emailOverlay, 0.3, { autoAlpha: 1, ease: Power1.easeInOut });

    //close timeline
    const emailCloseTl = gsap.timeline({ paused:true });
    emailCloseTl.to(emailOverlay, 0.3, { autoAlpha: 0, ease: Power1.easeInOut }, "-=0.2");


    openEmailOverlay.addEventListener("click", (e) => {
        e.preventDefault();
        body.classList.add(stopScrollingClass, isActiveClass);
        openEmailAnimations(emailOpenTl, emailCloseTl);         

    });

    closeEmailOverlay.addEventListener("click", (e) => {
        e.preventDefault();
        closeEmailAnimations(emailOpenTl, emailCloseTl);
        body.classList.remove(stopScrollingClass, isActiveClass);
    });
}

 //functions
 function openEmailAnimations(emailOpenTl, emailCloseTl) {
    emailCloseTl.pause();
    emailOpenTl.restart();
}

function closeEmailAnimations(emailOpenTl, emailCloseTl) {
    emailOpenTl.pause();
    emailCloseTl.restart();
}